if ( !customElements.get( 'announcement-bar' ) )
{
	class AnnouncementBar extends HTMLElement {
		constructor() {
			super();
			this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

			FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
		}

		getNextSlideButton() {
			return this.querySelector('.swiper-button-next');
		}

		getPrevSlideButton() {
			return this.querySelector('.swiper-button-prev');
		}

		get getSlideItems() {
			return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
		}

		isAutoplayEnabled() {
			return this.hasAttribute('autoplay');
		}

		getAutoplaySpeed() {
			return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
		}

		initializeCarousel() {
			if (this.getSlideItems.length > 1) {
				this.carousel = new FoxTheme.Carousel(
					this,
					{
						navigation: {
							nextEl: this.getNextSlideButton(),
							prevEl: this.getPrevSlideButton(),
						},
						loop: true,
						autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false,
					},
					[FoxTheme.Swiper.Autoplay]
				);
				this.carousel && this.carousel.init();

				if (Shopify.designMode) {
					this.addEventListener('shopify:block:select', (event) => {
						this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
					});
				}
			}
		}
	}
	customElements.define('announcement-bar', AnnouncementBar);
}